module.exports = __webpack_public_path__ + "img/facebook.d52cdb37.svg";